import { cn } from '@/lib/utils';

import { getWrapperMaxWidth } from '@/cms/utils';
import BadgeStrapi from '@/components/atoms/badge/BadgeStrapi';
import { OfferCountdownStatus } from '@/components/atoms/countdown';
import RichTextFieldStrapi from '@/components/atoms/RichTextField/RichTextFieldStrapi';

import { getBannerColorScheme } from './helpers';
import { BannerContentProps } from './types';
import { applyToAllRTFVariants } from '@/components/atoms/RichTextField/utils';

export const BannerContent = ({
  bannerText,
  endDate,
  bannerBadge,
  colorScheme,
}: BannerContentProps) => {
  const colors = getBannerColorScheme(colorScheme);
  const isBadgeVisible = !!bannerBadge && !endDate;
  const isCountdownVisible = !!endDate && !bannerBadge;

  return (
    <div
      className={cn(
        'light',
        'flex h-full min-h-10 w-full flex-col items-start sm:items-center justify-center gap-x-4 gap-y-5 md:flex-row md:gap-y-0',
        getWrapperMaxWidth('full')
      )}
    >
      <div
        className={cn(
          'flex items-center justify-end gap-3 text-center md:text-left',
          getWrapperMaxWidth('full')
        )}
      >
        {isBadgeVisible && (
          <div className='hidden headerLg:block'>
            <BadgeStrapi
              block={bannerBadge}
              inner={{
                variant: 'filled',
                size: 's',
                classNames: {
                  root: cn(colors.badgeText, colors.badgeBg),
                },
              }}
            />
          </div>
        )}
        {isCountdownVisible && (
          <div className='hidden headerLg:block'>
            <OfferCountdownStatus
              expiry={endDate}
              classNames={{
                text: cn(colors.countdownText, 'text-body-l-bold'),
                root: colors.countdownBg,
              }}
            />
          </div>
        )}
        <div
          className={cn(
            'text-body-l text-left text-wrap max-w-[400px] sm:max-w-none mr-4'
          )}
        >
          <RichTextFieldStrapi
            block={bannerText}
            classNames={{
              ...applyToAllRTFVariants(cn(colors.text)),
              link: { root: cn('font-medium', colors.text) },
            }}
          />
        </div>
      </div>
    </div>
  );
};
